module.exports = __webpack_public_path__ + "media/images/story/icon/pencil-36069dddbbdad662476d8b03a4594bfd.svg";